import { Component, EventEmitter, Output } from '@angular/core';
import { NavController } from 'ionic-angular';
/**
 * Generated class for the ParenttabsPage tabs.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'search-page',
  templateUrl: 'search.html'
})
export class SearchPage {

  constructor(public navCtrl: NavController) {
  }


  @Output() messageEvent = new EventEmitter<boolean>();

  closeSearch(event) {
    this.messageEvent.emit(false);
  }

  ionViewWillLeave() {

    /*  .then(onSuccess)
     .catch(onError); */

  }


}
